$(()=>{
   $('.faqList-title').click(function() {
      $(this).parents('.faqList-item').find('.faqList-body').slideToggle(200);
   });
});